var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    clipPath: "url(#clip0_12_13950)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7981 28.7994C22.7508 28.7994 29.1978 22.3524 29.1978 14.3997C29.1978 6.44696 22.7508 0 14.7981 0C6.84539 0 0.398438 6.44696 0.398438 14.3997C0.398438 22.3524 6.84539 28.7994 14.7981 28.7994Z",
    fill: "url(#paint0_linear_12_13950)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.6158 8.56836H9.98047C8.09006 8.56836 6.55762 10.1009 6.55762 11.9912V16.8079C6.55762 18.6983 8.09011 20.2308 9.98047 20.2308H19.6158C21.5062 20.2308 23.0386 18.6983 23.0386 16.8079V11.9912C23.0386 10.1009 21.5061 8.56836 19.6158 8.56836ZM17.3008 14.6339L12.7942 16.7833C12.674 16.8406 12.5353 16.7531 12.5353 16.6201V12.1869C12.5353 12.0519 12.6777 11.9644 12.798 12.0255L17.3046 14.3092C17.4388 14.3771 17.4364 14.5693 17.3008 14.6339Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_13950",
    x1: 14.7981,
    y1: 0,
    x2: 14.7981,
    y2: 28.7994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F32313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A01F15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_13950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.7994,
    height: 28.7994,
    fill: "white",
    transform: "translate(0.397949)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.cbdf0386fbb22ee76458161720c53f7e.svg";
export { ForwardRef as ReactComponent };